import { useState } from 'react';

interface IPasswordFieldProps {
    name: string;
    label?: string;
    helperText?: string;
    error?: string;
    required?: boolean;
    value: string
    onChange: ((name: string, value: any) => void)
    disabled: boolean;
}
export const DEFAULT_PASSWORD_PLACEHOLDER = 'RuDesktop';
export const ENCODE_PASSWORD_PREFIX = 'ANSIBLE_VAULT:ENCODE:';


function PasswordField({ name, label, helperText, error, required, value, disabled, onChange }: IPasswordFieldProps) {
    const [password, setPassword] = useState(value ? DEFAULT_PASSWORD_PLACEHOLDER : '');
    const [passwordSet, setPasswordSet] = useState(false);


    const updatePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        let InputPassword

        if (passwordSet) {
            InputPassword = event.target.value;
        }
        else {
            InputPassword = event.target.value === DEFAULT_PASSWORD_PLACEHOLDER.slice(0, -1) ? '' : event.target.value.slice(-1)
            setPasswordSet(true);

        }
        setPassword(InputPassword);
        onChange(name, ENCODE_PASSWORD_PREFIX + InputPassword);
    };

    const rootClasses = [
        'rd-input',
        'rd-input--medium',
        'rd-input--floating',
        'rd-input--password',
        error ? 'rd-input--error' : '',
        disabled ? 'rd-input--disabled' : '',
        password ? 'has-value' : '',
    ].filter(Boolean).join(' ');

    const labelClasses = [
        'rd-input__label',
        required ? 'rd-input__label--required' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={rootClasses}>
            <div className="rd-input__wrapper">
                <input
                    className="rd-input__field"
                    type="password"
                    name={name}
                    value={password}
                    placeholder=" "
                    required={required}
                    disabled={disabled}
                    autoComplete="off"
                    onChange={updatePassword}
                />
                {label && <label className={labelClasses}>{label}</label>}
            </div>
            {error && <span className="rd-input__error-text">{error}</span>}
            {helperText && !error && <span className="rd-input__helper-text">{helperText}</span>}
        </div>
    );
}


export default PasswordField;
